

var nrpSwitch = "<div class='bubbleInfoCon'>"
+ "<div class='nrp_tips'>"
+ "<p class='title'><strong>收费退订取消政策</strong></p>"
+ "<p>开航前<span class='blue'>30</span>天（含）以外取消订单，将收取1000人民币/人起作为取消费用；享受星际、天际、海际权益的房型将收取船费全款10%或1000元人民币/人（二者取其高）作为取消费用（不包括港务税费）</p>"
+ "<p>开航前第<span class='blue'>29-8</span>天取消订单，收取船费<span class='blue'>全款的50%</span>作为取消费用（不包括港务税费）；若船票全款的50%金额少于1000元/人，则收取1000元/人作为取消费用。</p>"
+ "<p>开航前第<span class='blue'>7-0</span>天取消订单，收取船费<span class='blue'>全款的100%</span>作为取消费用（不包括港务税费）；</p>"
+ "<p>关于船或航次修改，乘客姓名及其他个人信息修改政策，请详见“预订政策-退改签说明”。</p>"
+ "</div>"
+ "</div>";

var timeOutSwitch = "<div class='bubbleInfoCon'>"
+ "<div class='normal_tips' style='margin-bottom:20px'>"
+ "<p class='title'><strong>1.订单相关的退订及修改政策：</strong></p>"
+ "<p id='pointInPopup'>开航前第7-0天取消订单，<span class='red'>收取船票全款的100%作为取消费用</span>（不包括港务税费）。</p>"
+ "<p id='pointInPopup'>开航前7天及以内，<span class='red'>客人的任何信息都不得更改，</span>请确认个人信息填写无误。</p>"
+ "</div>"
+ "<div class='normal_tips'>"
+ "<p class='title'><strong>2.在线值船：</strong></p>"
+ "<p>当您的订单状态更新为“未出行”时，您可进行“在线值船”。</p>"
+ "<p><span class='red'>在线值船将于开航前72小时关闭。</span></p>"
+ "<p>如您未完成在线值船，<span class='red'>须在登船日下午14:00至下午14:30间，</span>至上海宝山区宝杨路1号吴淞口国际邮轮港码头登船办票大厅（T3）排队等候，并随身携带有效护照原件（航次结束6个月以上有效期）、护照照片页复印件1份（如含韩国行程请准备复印件2份）。</p>"
+ "</div>"
+ "</div>";

var nonrpSwitch = "<div class='bubbleInfoCon'>"
+ "<div class='normal_tips'>"
+ "<p class='title'><strong>常规退订取消政策</strong></p>"
+ "<p>开航<span class='blue'>45</span>天（不含）之前取消订单，可<span class='blue'>全额退款</span>；</p>"
+ "<p>开航前第<span class='blue'>45-30</span>天取消订单，将收取1000人民币/人起作为取消费用；享受星际、天际、海际权益的房型将收取船费全款10%或1000元人民币/人（二者取其高）作为取消费用（不包括港务税费）</p>"
+ "<p>开航前第<span class='blue'>29-8</span>天取消订单，收取船票<span class='blue'>全款的50%</span>作为取消费用（不包括港务税费）；若船票全款的50%金额少于1000元/人，则收取1000元/人作为取消费用。</p>"
+ "<p>开航前第<span class='blue'>7-0</span>天取消订单，收取船票<span class='blue'>全款的100%</span>作为取消费用（不包括港务税费）；</p>"
+ "<p>关于船或航次修改，乘客姓名及其他个人信息修改政策，请详见“预订政策-退改签说明”。</p>"
+ "</div>"
+ "</div>";

var fortyEightHoursNrpSwitch = "<div class='bubbleInfoCon'>"
+ "<div class='normal_tips'>"
+ "<p class='bubbleInfoCon-title'>退改无忧</p>"
+ "<p><strong>取消政策：</strong></p>"
+ "<p>2022年03月31日（含）前预订2022年9月30日（含）前出发的“皇家加勒比国际游轮”品牌下的中国母港及海外航次可享受无忧退改计划。具体政策如下：</p>"
+ "<p>开航<span class='blue'>7</span>天（不含）前取消订单，可<span class='blue'>全额退款</span>；</p>"
+ "<p>开航<span class='blue'>2</span>天（不含）前改签航次，船票费用及港务税费的差价将遵循多退少补原则，不收取额外的改签费用，可以改签至2022年间出发的中国母港及海外航次；</p>"
+ "<p>开航<span class='blue'>2</span>天 (不含）前取消订单，可获得港务税费<span class='blue'>全额退款</span>，以及与游轮公司实收船票费用（不含港务税费）等额的未来航次抵用金※</p>"
+ "<p>开航<span class='blue'>2</span>天内取消订单，收取船票<span class='blue'>费用的100%</span>作为取消费用（不包括港务税费）。</p>"
+ "<p>针对<strong>香港出发海上游航次</strong>的无忧退改计划，请点击查看<a href='https://www.royalcaribbean.com/hkg/zh/cruise-with-confidence' target='_blank'>具体政策</a>。(https://www.royalcaribbean.com/hkg/zh/cruise-with-confidence)</p>"
+ "<p><strong>※未来航次抵用金（下称“抵用金”）使用规则：</strong></p>"
+ "<p>1、  通过“皇家加勒比国际游轮”中国大陆地区的官方渠道及合作旅行社，新预订2022年9月30日（含）前出发的“皇家加勒比国际游轮”品牌下的中国母港及海外航次，可使用抵用金，具体航次和舱房以预订当时的在售情况和实际库存为准。</p>"
+ "<p>2、  抵用金仅限本人（即抵用金凭证所载的持有人）为出行客人时使用，请在预订时出示抵用金凭证。</p>"
+ "<p>3、  抵用金只能抵扣游轮船票费用，不能抵扣船票费用以外的任何其他费用，如港务税费、游轮服务费、岸上观光费用等。</p>"
+ "<p>4、  如果抵用金金额大于新预订船票的价格，差额部分将重新签发一张等值额度的未来航次抵用金。</p>"
+ "<p>5、  抵用金不能兑换成现金、不可转让、不可抵扣订金或定金。</p>"
+ "<p>6、  每位乘客每个航次仅限使用一张未来航次抵用金。</p>"
+ "<p>7、  若此抵用金需要兑换成美金抵扣船票的，汇率以抵用当日中国人民银行公布的人民币兑换美元的中间价位准。</p>"
+ "<p>8、  抵用金凭证所载使用规则如与本规则有冲突的，以凭证所载使用规则为准。</p>"
+ "<p>9、  皇家加勒比国际游轮对抵用金的使用保留解释权。</p>"

+ "<p class='fortyEightHoursNrpSwitchTips'>关于船或航次修改，乘客姓名及其他个人信息修改政策，请详见本页-退改签说明</p>"
+ "</div>"
+ "</div>";
var sevenDayNrpSwitch = "<div class='bubbleInfoCon'>"
+ "<div class='normal_tips'>"
+ "<p class='bubbleInfoCon-title'>开航7天前免费退改</p>"
+ "<p><strong>取消政策：</strong></p>"

+ "<p>开航前第<span class='blue'>8天以外</span>取消订单，可全额退款；</p>"
+ "<p>开航前第<span class='blue'>7天及以内</span>取消订单，收取船费<span class='blue'>全款的50%</span>作为取消费用（不包括港务税费）。</p>"
+ "<p>关于船或航次修改，乘客姓名及其他个人信息修改政策，请详见常见问题-退改政策。</p>"
+ "</div>"
+ "</div>";

export default {
    nrp: {
        title: '收费退订',
        priceType: '特惠人均价',
        description: nrpSwitch
    },
    rp: {
        title: '常规退订',
        priceType: '优惠人均价',
        description: nonrpSwitch
    },
    outTime: {
        type:'timeOut',
        title: '临近航线',
        priceType: '优惠价',
        description: timeOutSwitch
    },
    sevenDayNrp: {
        title: '开航7天前免费退改',
        priceType: '优惠价',
        description: sevenDayNrpSwitch
    },
    fortyEightHoursNrp: {
        title: '退改无忧',
        priceType: '优惠价',
        description: fortyEightHoursNrpSwitch
    }
}
